export var ChartFilterOptions;
(function (ChartFilterOptions) {
    ChartFilterOptions[ChartFilterOptions["Default"] = 0] = "Default";
    ChartFilterOptions[ChartFilterOptions["AllData"] = 1] = "AllData";
    ChartFilterOptions[ChartFilterOptions["Custom"] = 2] = "Custom";
})(ChartFilterOptions || (ChartFilterOptions = {}));
